/* __next_internal_client_entry_do_not_use__ Default auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { useSitecoreContext } from 'lib/hooks/useSitecoreContext';
import { useMemo, Suspense } from 'react';
import { withStandardComponentWrapper } from 'helpers/HOC';
import ExpertListSearchWidget from 'widgets/ExpertList';
import { usePathname } from 'next/navigation';
import { parseStyleParams } from 'lib/utils/style-param-utils';
const ExpertList = (props)=>{
    const pathname = usePathname();
    const { sitecoreContext } = useSitecoreContext();
    const styles = parseStyleParams(props.params, [
        'cards'
    ]);
    const colCount = styles?.cards?.cardsPerRow;
    // Access data from the correct nested structure
    const fieldsWithData = props?.fields;
    const itemData = fieldsWithData?.data?.item;
    const topExpertsData = itemData?.topExperts?.targetItems || fieldsWithData?.topExperts?.targetItems || props?.fields?.topExperts;
    // Get page template ID from route
    const pageTemplateId = sitecoreContext?.route?.templateId;
    const mergeTextField = (graphqlField, fallback)=>{
        if (graphqlField == null) return fallback;
        const raw = typeof graphqlField === 'object' && graphqlField !== null && 'jsonValue' in graphqlField && graphqlField.jsonValue !== undefined ? graphqlField.jsonValue : graphqlField;
        if (raw != null && typeof raw === 'object' && 'value' in raw) {
            return raw;
        }
        return fallback;
    };
    const expertListData = useMemo(()=>({
            rfkId: 'rfkid_expert_profile',
            searchPlaceholder: mergeTextField(itemData?.searchPlaceholder, props?.fields?.searchPlaceholder),
            noSearchResult: mergeTextField(itemData?.noSearchResult, props?.fields?.noSearchResult),
            filterText: mergeTextField(itemData?.filterText, props?.fields?.filterText),
            cardsCTAText: mergeTextField(itemData?.cardsCTAText, props?.fields?.cardsCTAText),
            cta1: itemData?.cta1,
            cta2: itemData?.cta2,
            topExperts: topExpertsData,
            pageTemplateId,
            colCount
        }), [
        itemData,
        topExpertsData,
        pageTemplateId,
        colCount
    ]);
    // Stable per-route key (avoid extractPath / hydration churn remounting the widget forever).
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: null,
        children: /*#__PURE__*/ _jsx(ExpertListSearchWidget, {
            ...expertListData
        }, pathname)
    });
};
export const Default = withStandardComponentWrapper(ExpertList);
